import {CarouselClickHandleClick} from 'helpers-ga4';

const DirectionLock = function (Glide, Components, Events) {
  let startX, startY, lockDecided;

  return {
    mount() {
      Components.Html.wrapper.addEventListener(
        'touchstart',
        (e) => {
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          lockDecided = false;
        },
        {passive: true},
      );

      Components.Html.wrapper.addEventListener(
        'touchmove',
        (e) => {
          if (lockDecided) return;
          lockDecided = true;
          const dx = Math.abs(e.touches[0].clientX - startX);
          const dy = Math.abs(e.touches[0].clientY - startY);
          if (dy > dx) {
            Glide.disable();
            Components.Html.wrapper.addEventListener(
              'touchend',
              () => Glide.enable(),
              {once: true},
            );
          }
        },
        {passive: true},
      );
    },
  };
};

class Carousel extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const self = this;
    document.querySelectorAll('petivity-story-sliders').forEach((carousel) => {
      let options = {
        type: 'carousel',
        perView: 1,
        focusAt: 'center',
        gap: 200,
        breakpoints: {
          1024: {
            perView: 1,
            peek: {
              before: 65,
              after: 65,
            },
            gap: 30,
          },
          576: {
            perView: 1,
            peek: {
              before: 40,
              after: 40,
            },
            gap: 22,
          },
        },
        animationDuration: 1000,
      };

      if (!carousel.classList.contains('glide--ltr')) {
        const slides = carousel.querySelectorAll('.glide__slide');
        if (slides.length === 1) {
          const singleSlideOverrides = {
            type: 'slider',
            rewind: false,
            draggable: false,
            swipeThreshold: false,
            dragThreshold: false,
            breakpoints: {
              1024: {
                perView: 1,
                peek: {
                  before: 30,
                  after: 30,
                },
                gap: 30,
              },
              576: {
                perView: 1,
                peek: {
                  before: 20,
                  after: 20,
                },
                gap: 22,
              },
            },
          };
          options = {...options, ...singleSlideOverrides};
        }

        const glide = new Glide(carousel, options);

        glide.on('run.after', function (event) {
          if (event.direction != '=' && event.steps === 0) {
            self.ga4ArrowsNotification(
              glide,
              carousel,
              event.direction === '<' ? 'previous' : 'next',
            );
            self.announceActiveSlide(carousel);
          } else if (
            event.direction != '=' &&
            typeof event.steps === 'string'
          ) {
            self.ga4ArrowsNotification(glide, carousel, 'swipe');
          }

          self.updateInertSlides(carousel);
        });

        glide.on('mount.after', function () {
          self.updateInertSlides(carousel);
        });

        glide.mount({DirectionLock});
      }
    });
  }

  updateInertSlides(carousel) {
    carousel.querySelectorAll('.glide__slide').forEach((slide) => {
      const isActive = slide.classList.contains('glide__slide--active');
      const focusableElements = slide.querySelectorAll(
        'a, button, input, select, textarea, [tabindex]',
      );

      if (isActive) {
        slide.removeAttribute('inert');
        slide.removeAttribute('aria-hidden');
        focusableElements.forEach((el) => {
          el.removeAttribute('tabindex');
          el.removeAttribute('aria-hidden');
        });
      } else {
        slide.setAttribute('inert', '');
        slide.setAttribute('aria-hidden', 'true');
        focusableElements.forEach((el) => {
          el.setAttribute('tabindex', '-1');
          el.setAttribute('aria-hidden', 'true');
        });
      }
    });
  }

  announceActiveSlide(carousel) {
    const liveRegion = carousel.querySelector(
      '.petivity-story-sliders__live-region',
    );
    const activeSlide = carousel.querySelector('.glide__slide--active');
    if (!liveRegion || !activeSlide) return;

    const slides = carousel.querySelectorAll('.glide__slide');
    const activeIndex = Array.prototype.indexOf.call(slides, activeSlide);
    const heading = activeSlide.querySelector(
      '.petivity-story-sliders__heading',
    );
    const personalTitle = activeSlide.querySelector(
      '.petivity-story-sliders__personal p',
    );
    const slideLabel = (
      heading?.textContent ||
      personalTitle?.textContent ||
      ''
    ).trim();

    liveRegion.textContent = slideLabel
      ? `Displaying slide ${activeIndex + 1} of ${slides.length}: ${slideLabel}`
      : `Displaying slide ${activeIndex + 1} of ${slides.length}`;

    clearTimeout(liveRegion._clearTimeout);
    liveRegion._clearTimeout = setTimeout(() => {
      liveRegion.textContent = '';
    }, 2000);
  }

  ga4ArrowsNotification(glide, carousel, direction) {
    const activeIndex = glide.index;
    const activeSlide = carousel.querySelector('.glide__slide--active');
    const slideAsset = activeSlide.querySelector('img');
    const item = {
      page_type: `${document.title}`,
      carousel_location: `${window.location.pathname}`,
      carousel_name: 'Storyteller Slider',
      interaction_type: 'arrow_click',
      carousel_direction: direction,
      carousel_item_index: activeIndex,
      carousel_item_label: slideAsset.getAttribute('alt'),
      media_type: 'image',
      carousel_type: 'story_slider',
    };
    CarouselClickHandleClick(item);
  }
}
customElements.define('petivity-story-sliders', Carousel);
